const initialstate = {}

function aboutInterview(state = initialstate, action) {
    switch (action.type) {
        case "set_aboutInterview":
            return { ...state, ...action.payload }
        case "clear_aboutInterview":
            return initialstate

        default:
            return state
    }
}

export default aboutInterview;